const CACHE_KEY = "smart_companies_by_user_cache_v1";
const CACHE_VERSION = 3;

/**
 * @param {unknown} list
 * @param {string|null|undefined} storedId
 * @param {string|null|undefined} currentSelectedId
 * @returns {{ chosen: object|null, shouldClearStored: boolean }}
 */
export function pickCompanyFromList(list, storedId, currentSelectedId) {
  if (!Array.isArray(list) || list.length === 0) {
    return { chosen: null, shouldClearStored: false };
  }

  const byId = (id) => list.find((c) => String(c.id) === String(id));

  let chosen = null;
  let shouldClearStored = false;

  if (storedId) {
    chosen = byId(storedId);
    if (!chosen) {
      shouldClearStored = true;
    }
  }

  if (!chosen && currentSelectedId) {
    chosen = byId(currentSelectedId);
  }

  if (!chosen) {
    const demoExists = list.find(
      (company) => String(company?.id) === "68716e6410063d9b832c277c"
    );
    const filtered = list.filter(
      (company) => String(company?.id) !== "5ed465daf8e0ab00455991ab"
    );
    const [firstNonScfo] = filtered;
    chosen = demoExists || firstNonScfo || null;
  }

  return { chosen, shouldClearStored };
}

/**
 * @param {string|null|undefined} userId
 * @returns {object[]|null}
 */
export function readCompanyListCache(userId) {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      !parsed ||
      parsed.v !== CACHE_VERSION ||
      String(parsed.userId) !== String(userId) ||
      !Array.isArray(parsed.companies)
    ) {
      return null;
    }
    return parsed.companies;
  } catch {
    return null;
  }
}

/**
 * @param {string|null|undefined} userId
 * @param {object[]} companies
 */
export function writeCompanyListCache(userId, companies) {
  if (!userId || !Array.isArray(companies)) return;
  try {
    const payload = {
      v: CACHE_VERSION,
      userId: String(userId),
      savedAt: Date.now(),
      companies,
    };
    localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
  } catch (e) {
    console.warn("companyListCache: write failed", e);
  }
}

export function clearCompanyListCache() {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    /* ignore */
  }
}
